module.exports = __webpack_public_path__ + "img/map_1_click.8113601a.svg";